import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-peoplesearchpopup',
    templateUrl: './peoplesearchpopup.component.html',
    styleUrls: ['./peoplesearchpopup.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule]
})
export class PeoplesearchpopupComponent {
  @Input() organizationKey = ""
  @Input() projectKey = ""
  @Input() workpackageKey = ""
  @Input() userId = ""
  @Input() userEmail = ""
  @Input() userName = ""
  @Output() foundUsers = new EventEmitter<string[]>();


  showModal = true
  users: {"id": string, "name": string, "email": string, "checked": boolean}[] = []
  userQuery = ""
  message = ""
  yourNameChecked = false

  constructor(private firestore: FirestoreService) {

  }

  ngAfterViewInit() {

  }

  searchUsers(query: string) {
    this.users.length = 0
    this.message = "Searching for users..."
    const smallQuery = query.toLowerCase()
    this.firestore.getOrganizationUsers(this.organizationKey).then((result) => {
      result.forEach(u => {
        const name = u.get("displayName")
        const email = u.get("email")
        if (name != undefined && email != undefined && (name.toLowerCase().includes(smallQuery) || (email.toLowerCase().includes(smallQuery)))) {
          this.users.push({"id": u.id, "name": name, "email": email, "checked": false})
        }
      })
      if (this.users.length == 0) {
        this.message = "No matching users found"
      }
    })
  }
  
    closeModal() { // closing modal window is done by changing parameter showModal on parent component
      this.foundUsers.emit([]);
    }

    addUserToWorkpackage() {
      this.users.forEach(u => {
        if (u.checked == true) {
          this.firestore.addUserToWorkpackage(this.organizationKey, this.workpackageKey, u.id)
        }
      })
      if (this.yourNameChecked == true) {
        this.addYouToWorkpackage()
      }
      this.closeModal()
    }

    addYouToWorkpackage() {
      this.firestore.addUserToWorkpackage(this.organizationKey, this.workpackageKey, this.userId)
    }

    checkYouName() {
      this.yourNameChecked = !this.yourNameChecked
    }

    checkName(i: number) {
      this.users[i].checked = !this.users[i].checked
    }

}
